import request from '@/utils/request'

export function getList(params) {
  return request({
    url: '/bTProducts/load',
    method: 'get',
    params
  })
}

export function add(data) {
  return request({
    url: '/bTProducts/add',
    method: 'post',
    data
  })
}

export function update(data) {
  return request({
    url: '/bTProducts/update',
    method: 'post',
    data
  })
}

export function del(data) {
  return request({
    url: '/bTProducts/delete',
    method: 'post',
    data
  })
}

